<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.15153 15.6251C2.46073 15.095 3.14107 14.916 3.67112 15.2252L12 20.0837L20.3289 15.2252C20.8589 14.916 21.5393 15.095 21.8485 15.6251C22.1577 16.1551 21.9786 16.8355 21.4486 17.1446L12.5598 22.3297C12.2139 22.5315 11.7861 22.5315 11.4402 22.3297L2.55143 17.1446C2.02138 16.8355 1.84234 16.1551 2.15153 15.6251Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.15153 11.1807C2.46073 10.6507 3.14107 10.4716 3.67112 10.7808L12 15.6393L20.3289 10.7808C20.8589 10.4716 21.5393 10.6507 21.8485 11.1807C22.1577 11.7107 21.9786 12.3911 21.4486 12.7003L12.5598 17.8854C12.2139 18.0872 11.7861 18.0872 11.4402 17.8854L2.55143 12.7003C2.02138 12.3911 1.84234 11.7107 2.15153 11.1807Z"
			:fill="color"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.4402 1.15135C11.7861 0.949549 12.2139 0.949549 12.5598 1.15135L21.4486 6.33645C21.7899 6.53556 21.9998 6.901 21.9998 7.29618C21.9998 7.69136 21.7899 8.0568 21.4486 8.25592L12.5598 13.441C12.2139 13.6428 11.7861 13.6428 11.4402 13.441L2.55143 8.25592C2.21008 8.0568 2.00018 7.69136 2.00018 7.29618C2.00018 6.901 2.21008 6.53556 2.55143 6.33645L11.4402 1.15135ZM5.31638 7.29618L12 11.195L18.6836 7.29618L12 3.39741L5.31638 7.29618Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#597393',
		},
	},
};
</script>
